module.exports = __webpack_public_path__ + "fonts/KFOmCnqEu92Fr1Mu7WxKOzY.a8be5b46.woff2";